module.exports = __webpack_public_path__ + "img/kjsy_gallery4.4be00323.jpg";